import React from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import VehicleManagmentTable from './VehicleManagmentTable';
import { AppBar } from '@mui/material';
import { AntTab, AntTabs } from '../../../components/ant-tab';
import { Grid, makeStyles, Paper } from '@material-ui/core';
import CalendarVehicle from './CalendarVehicle';
import Spacer from '../../../components/Spacer';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
        elevation: 0,
      },
      
    tab: {
        width: "50%",
      },
      AppBar: {
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
      },
  }));

const VehicleManagmentList = () => {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    return (
        <MainContainer {...headerDataImmo}>

            {/* <AppBar position="static" color="default" className={classes.AppBar}>
                      <AntTabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                      >
                        <AntTab label="Gestion des voitures" className={classes.tab} />
                        <AntTab label="Calendrier des voitures" className={classes.tab} />
                      </AntTabs>
                    </AppBar> */}
                    <VehicleManagmentTable />

                    {/* {value === 0 && (
        <Grid item xl={12} md={12}>
             <Grid container spacing={3}>
                <Grid item xs={12}>
                <Spacer y={4} />
                    <VehicleManagmentTable />
                </Grid>
            </Grid>
        </Grid>
      )}
       {value === 1 && (
        <Grid item xl={12} md={12}>
             <Grid container spacing={3}>
                <Grid item xs={12}>
                <Spacer y={2} />
                    <CalendarVehicle />
                </Grid>
            </Grid>
        </Grid>
      )} */}
        </MainContainer>
    );
};

export default VehicleManagmentList;